import { Component } from '@angular/core';
import { FeedbackPlatformCommitteeMemberEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Committee Members') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformcommitteemember-form',
    templateUrl: './feedbackplatformcommitteemember.form.component.html'
})
export class FeedbackPlatformCommitteeMemberFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformCommitteeMemberEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

